/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSharedNavigationSingleResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { connectProjectRoute } from '@jira/router-routes__connect-routes/src/connectProjectRoute.tsx';
import { getProjectConnectRouteDefaultResources } from './common/index.tsx';
import { connectProjectsPageEntrypoint } from './ui/spa/connect/projects/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const connectProjectRouteEntry: Route = createEntry(connectProjectRoute, () => ({
	group: 'connect',

	navigation: {
		menuId: MenuIdProjects,
		horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
	},

	layout: genericProjectLayout,
	ufoName: 'jira-connect',

	// Match resources that are fetched for legacyConnectProjectRouteEntry
	// See src/packages/router-routes/legacy-connect-project-entries/src/index.tsx
	resources: [
		...getProjectConnectRouteDefaultResources(),
		...getServiceDeskSharedNavigationSingleResources(),
		getConsolidationStateResource(),
	],

	entryPoint: () => connectProjectsPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
